import { useShouldRemoveFileUploadPrefix } from '@modules/common/hooks';
import { replaceSourceNameForTenantIfRequired } from '@modules/common/utils';
import { Box, Paper, Stack, Typography } from '@mui/material';
import {
  EqlField,
  EqlFieldMetadataReference,
  IntegrationChannelType,
} from 'generated/graphql';

interface CommonFieldDetailsTooltipContentProps {
  field: EqlField;
}

export const CommonFieldDetailsTooltipContent = ({
  field,
}: CommonFieldDetailsTooltipContentProps) => {
  const metadataReferences = field.detail?.metadata?.references ?? [];
  const shouldRemoveFileUploadPrefix = useShouldRemoveFileUploadPrefix();

  const getSourceName = (metadataReference: EqlFieldMetadataReference) => {
    const sourceName = replaceSourceNameForTenantIfRequired(
      (shouldRemoveFileUploadPrefix
        ? metadataReference.source.replaceAll(
            `${IntegrationChannelType.FileUpload}-`,
            '',
          )
        : metadataReference.source
      ).trim() ?? '',
    );
    return sourceName;
  };

  return (
    <Stack m={1}>
      <Typography variant="body2" pb={1}>
        {field.displayName}
      </Typography>
      <Paper sx={{ p: 1, maxHeight: 160, overflowY: 'auto' }}>
        <Stack
          direction="column"
          alignItems="start"
          spacing={1}
          justifyContent="center"
        >
          {metadataReferences.map((metadataReference) => {
            return (
              <Stack direction="row" spacing={1} key={metadataReference.key}>
                <Box
                  component="img"
                  width="100%"
                  maxWidth={24}
                  height="auto"
                  sx={{
                    objectFit: 'contain',
                  }}
                  src={metadataReference.iconURL}
                  alt={metadataReference.source}
                />
                <Stack direction="column">
                  <Typography variant="caption">
                    {metadataReference.displayName}
                  </Typography>
                  <Typography variant="caption" color="text.secondary">
                    From {getSourceName(metadataReference)}
                  </Typography>
                </Stack>
              </Stack>
            );
          })}
        </Stack>
      </Paper>
    </Stack>
  );
};
